import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { get } from 'lodash';
import currencySym from 'currency-symbol-map';
import Reviews from '../../../../api/api-reviews';
import { InboxCTA } from '../inbox-cta';
import CustomOfferIOSModal from '../../app-bookings-custom/modals/custom-offer-ios-modal';
import { WithdrawUpdateModal } from '../../app-bookings-update/withdraw-update-modal';
import { UpdateBookingIOSModal } from '../../app-bookings-update/update-booking-ios-modal';
import { CancelBookingIOSModal } from '../../app-bookings-cancel/cancel-booking-ios-modal';
import ReviewOfferDetailsIOSModal from '../../app-bookings-custom/modals/ReviewOfferDetailsIOSModal';
import AddServicesIOSModal from '../../app-bookings-request/modals/AddServicesIOSModal';
import ReviewRequestIOSModal from '../../app-bookings-request/modals/ReviewRequestIOSModal';
import { renderBookingModal } from '../booking-action-modal';
import { ReviewForm } from '../../elements-forms/review';
import { Modal } from '../../elements-modal/modal';
import { SupportModal } from '../../elements-modal/support-modal';
import WithdrawOfferModal from '../../app-bookings-custom/modals/withdraw-offer-modal';
import rootReducer from '../../app-main/reducers';
import HostCustomOfferBanner from '../HostCustomOfferBanner';
import CurrentDetailsIOSModal from '../../app-bookings-current-details/current-details-ios-modal';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { intlGuestStatusTexts, intlHostStatusTexts } from './intl-booking-status-data';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { INBOX_CTA_TITLES } from './inbox-cta-data';
import { checkCCStateInterval } from '../../app-bookings-request/forms/bookingUtil';
import { InboxNextStepsSlider } from '../InboxNextStepsSlider/InboxNextStepsSlider';
import { ReferralsCard } from '../InboxNextStepsSlider/ReferralsCard';

export const GuestStatus = (firstName, expires, user, bookingID, cb2, listingId, pid, reviewID, reviewCb, payload, context, iosWebView, guestCanUpdate, canInstantBook, showCancellationSummary, hasNoContracts, accessToken, iosConcierge, hasInventoryItems, dispatch, showReferralBanner, redirectOnReviewSuccess, inviteCreated) => {
  /**
   *
   * @function
   * @name CTA Buttons
   * @param {Object}   - User Object
   * @param {String}   - Booking ID
   * @param {Function} - cb2
   * @param {String} - actionName
   * @param {String} - listingId
   * @param {String} - pid
   * @param {String} - reviewID
   * @param {Function} - reviewCb
   * @param {Object} - payload
   */

  const expiration = expires ? <span className="expire-pill"><FormattedMessage { ...intlGuestStatusTexts.expiresIn } values={{ expires: expires.display_string }} /></span> : '';
  const boltIcon = <img className="bolt-icon" src="/web-2/assets/images/bolt.png?v=rb" alt="bolt-icon" />;
  const isInstantBooking = (payload || {}).is_instant_booking;
  const creditsIssued = parseFloat(get(payload, 'credit_amount_issued')).toFixed(2);
  const currencySymbol = currencySym(get(payload, 'list_price.currency'));

  const prefix = SharedIntlProviderHOC.getUrlPrefix();
  const urlPrefix = prefix ? `/${prefix}` : '';

  // Check parameter iosConcierge passed from the mobile app to show
  // the concierge form right after request to book and when webview is opened
  if (iosConcierge && iosWebView) {
    const store = createStore(rootReducer, applyMiddleware(thunk));

    ReactDOM.render(
      <Provider store={store}>
        <SharedIntlProviderHOC>
          <AddServicesIOSModal
            accessToken={accessToken}
            bookingId={bookingID}
            user={user}
            finalCb={cb2}
            iosWebView
            addServices
            iosConcierge={iosConcierge}
          />
        </SharedIntlProviderHOC>
      </Provider>, document.body);
  }
  // start guest cta action functions
  function startBooking () {
    return context.router.push(`/bkc/${listingId}?request=${bookingID}`);
  }

  function exploreSpaces () {
    window.location.href = `${urlPrefix}/#a=search`;
  }

  function resendRequest () {
    window.location.href = `${urlPrefix}/pages/listings/${listingId}`;
  }

  function bookAgain () {
    window.location.href = `${urlPrefix}/pages/listings/${listingId}`;
  }

  function requestUpdate () {
    const addOnsStep = 'GUEST_UPDATE_NO_AUTH' === payload.obj_state && !guestCanUpdate;

    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <UpdateBookingIOSModal
              updateAction="REQUEST_UPDATE"
              accessToken={accessToken}
              user={user}
              bookingID={bookingID}
              customCb={cb2}
              iosBrowseAddOns={addOnsStep}
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('main-container'));
      return null;
    }

    if (addOnsStep) {
      return context.router.push(`/inbox/${bookingID}/guest-update-booking/add-ons`);
    }

    return context.router.push(`/inbox/${bookingID}/guest-update-booking`);
  }

  function browseAddOns () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <UpdateBookingIOSModal
              updateAction="REQUEST_UPDATE"
              accessToken={accessToken}
              user={user}
              bookingID={bookingID}
              customCb={cb2}
              iosBrowseAddOns
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('main-container'));
      return null;
    }
    return context.router.push(`/inbox/${bookingID}/guest-update-booking/add-ons`);
  }

  // used for host updates and custom offers
  function reviewOffer () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <ReviewOfferDetailsIOSModal
              accessToken={accessToken}
              bookingId={bookingID}
              user={user}
              iosWebView
              finalCb={cb2}
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }

    return context.router.push(`/inbox/${bookingID}/review-offer`);
  }

  function guestWithdraw () {
    renderBookingModal(bookingID, 'guest', 'withdraw', 'GUEST_WITHDRAW', cb2);
  }

  function guestCancel () {
    analyticsIntegrations.cancelBookingClicked({guest_id: user.SSOid, booking_id: bookingID });
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CancelBookingIOSModal
              bookingID={bookingID}
              customCb={cb2}
              profile={user}
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }
    return context.router.push(`/inbox/${bookingID}/cancel-booking`);
  }

  function noMetroServices () {
    const guestID = $('#main-nav').data('usr');
    const bookingId = payload.booking_id;
    const bookingObj = {
      booking_id: bookingId,
      guest_id: guestID,
      listing_id: payload.listing.listing_id,
      use_type: payload.listing.use_type,
      metro: payload.metro
    };
    window.open(`http://try.peerspace.com/add-services/?sso=${guestID}&bkg=${bookingId}&origin=message`, '_blank');
  }

  function hasMetroServices () {
    const guestID = $('#main-nav').data('usr');
    const bookingId = payload.booking_id;
    const bookingObj = {
      booking_id: bookingId,
      guest_id: guestID,
      listing_id: payload.listing.listing_id,
      use_type: payload.listing.use_type,
      metro: payload.metro
    };

    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <AddServicesIOSModal
              accessToken={accessToken}
              bookingId={bookingID}
              user={user}
              finalCb={cb2}
              iosWebView
              addServices
            />
          </SharedIntlProviderHOC>
        </Provider>, document.body);
      return null;
    }

    return context.router.push(`/add-services/${bookingId}`);
  }

  function attendeeShare (redirect, isInviteButton) {
    if (isInviteButton) {
      analyticsIntegrations.publicAttendee('attendee details: view and share', {
        label: bookingID,
        origin: 'booking'
      });
    } else {
      analyticsIntegrations.buttonClicked({
        button_name: 'Update invite',
        button_location: 'Booking details page'
      });
    }

    if (redirect) {
      context.router.push(`/invite/router/${pid}`);
    }
  }

  function viewInvite () {
    context.router.push(`/invite/${pid}`);
  }

  function withdrawUpdate () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <WithdrawUpdateModal
          viewAs={ payload.view_as }
          bookingID={ bookingID }
          callback={ cb2 }
          hasNoContracts={hasNoContracts}
          bookingData={payload}
          user={user}
        />
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  function review () {
    Reviews.read(`/${reviewID}`, PSSessions.Cookies('PSAccess'),
      (response) => {
        if (response.error || 400 < response.statusCode) {
          // Something went wrong when creating the message
          return console.log(response);
        }
        ReactDOM.render(
          <SharedIntlProviderHOC>
            <Modal
              addCloseIcon
              modalID="review-modal"
              closeBehavior={null}
              body={
                <ReviewForm
                  review={response}
                  user={user}
                  cbAction={reviewCb}
                  redirectOnSuccess={redirectOnReviewSuccess}
                />
              }
              footer={null}
              show
              modalSize="lg-size"
              modalType="standard"
            />
          </SharedIntlProviderHOC>, document.getElementById('modal-container')
        );
        return null;
      });
  }

  function contactSupport () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <SupportModal />
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  function viewCancellationDetails () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CancelBookingIOSModal
              bookingID={bookingID}
              customCb={cb2}
              profile={user}
              summary
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }
    return context.router.push(`/inbox/${bookingID}/cancellation-summary`);
  }
  // end guest cta action functions
  function cancelledCTAs () {
    const viewCancelDetailsCTA = (
      <InboxCTA
        ctaAction={viewCancellationDetails}
        title={ INBOX_CTA_TITLES.VIEW_CANCELLATION_DETAILS }
        id="view-cancellation-details-btn"
      />);

    const exploreCTA = [
      <InboxCTA
        ctaAction={exploreSpaces}
        title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
        primaryButton
        id="explore-spaces-btn"
      />
    ];

    const ctas = [
      <InboxCTA
        ctaAction={contactSupport}
        title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
        id="contact-support-btn"
      />
    ];

    if (showCancellationSummary) {
      ctas.splice(0, 0, exploreCTA, viewCancelDetailsCTA);

      if (iosWebView) {
        ctas.splice(0, 1);
      }
    }

    return ctas;
  }


  function routeToPaymentsPage () {
    window.location.href = '/account/methods';
  }

  function viewReceipt () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CurrentDetailsIOSModal
              accessToken={accessToken}
              bookingId={bookingID}
              iosWebView
              finalCb={cb2}
              dispatch={dispatch}
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }
    return context.router.push(`/inbox/${bookingID}/current-details`);
  }

  return {
    INQUIRED: {
      title: intlGuestStatusTexts.inquiredTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.inquiredMobileHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.inquiredMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.inquiredContent } values={{
        name: firstName,
        instantBook: canInstantBook
          ? iosWebView
            ? <FormattedMessage id='inbox.guest_status.book_listing_page' defaultMessage='From the listing page, use the Book Now button to instantly reserve your date.' />
            : <FormattedMessage id='inbox.guest_status.use_book_button' defaultMessage='Use the Book Now button to reserve your dates instantly.' />
          : iosWebView
            ? <FormattedMessage id='inbox.guest_status.start_booking_listing' defaultMessage='From the listing page, use the Start Booking button to send a booking request and reserve your date.' />
            : <FormattedMessage id='inbox.guest_status.start_booking_button' defaultMessage='Use the Start Booking button to send a booking request and reserve your date.' />
      }} />,
      buttons: iosWebView ? null :
        <InboxCTA
          ctaAction={startBooking}
          title={ canInstantBook
            ? INBOX_CTA_TITLES.BOOK_NOW
            : INBOX_CTA_TITLES.START_BOOKING
          }
          primaryButton
        />,
      borderColor: 'blue'
    },
    REQUESTED: {
      title: intlGuestStatusTexts.requestedTitle,
      titleData: { name: firstName },
      heading: <div><span><FormattedMessage { ...intlGuestStatusTexts.requestedHeading } values={{ name: firstName }} />&nbsp;</span></div>,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.requestedMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.requestedContent } />,
      nextSteps: (
        <>
          {payload && (
            <InboxNextStepsSlider
              inviteCreated={inviteCreated}
              showReferralCard={showReferralBanner}
              router={context?.router}
              pid={pid}
              bookingDetails={payload}
            />
          )}
        </>
      ),
      buttons: !payload ? null :
        <InboxCTA
          ctaAction={guestWithdraw}
          title={ INBOX_CTA_TITLES.WITHDRAW_BOOKING }
          primaryButton={payload.quote_submitted}
        />,
      borderColor: 'blue'
    },
    ACCEPTED: {
      title: intlGuestStatusTexts.acceptedTitle,
      titleData: { name: firstName },
      heading: <div>{isInstantBooking ? boltIcon : null}<FormattedMessage { ...intlGuestStatusTexts.acceptedHeading } /></div>,
      mobileHeading: <div>{isInstantBooking ? boltIcon : null}<FormattedMessage { ...intlGuestStatusTexts.acceptedMobileHeading } /></div>,
      content: <></>,
      nextSteps: !payload ? null : (
        <InboxNextStepsSlider
          inviteCreated={inviteCreated}
          showReferralCard={showReferralBanner}
          router={context?.router}
          pid={pid}
          bookingDetails={payload}
        />
      ),
      showRequestUpdateModal: !!payload && iosWebView && guestCanUpdate ? requestUpdate : null,
      buttons: !payload ? null :
        iosWebView ? [
          guestCanUpdate ?
            <InboxCTA
              ctaAction={requestUpdate}
              title={ INBOX_CTA_TITLES.UPDATE_BOOKING }
            /> : null,
          <InboxCTA
            ctaAction={guestCancel}
            title={ INBOX_CTA_TITLES.CANCEL_BOOKING }
          />
        ] : [
          inviteCreated ?
            <InboxCTA
              ctaAction={ () => { attendeeShare(true, false); } }
              title={ INBOX_CTA_TITLES.UPDATE_INVITE }
            /> : null,
          hasInventoryItems && guestCanUpdate ? <InboxCTA
            ctaAction={browseAddOns}
            title={ INBOX_CTA_TITLES.BROWSE_ADDONS }
          /> : null,
          guestCanUpdate ?
            <InboxCTA
              ctaAction={requestUpdate}
              title={ INBOX_CTA_TITLES.UPDATE_BOOKING }
            /> : null,
          <InboxCTA
            ctaAction={guestCancel}
            title={ INBOX_CTA_TITLES.CANCEL_BOOKING }
          />,
          <InboxCTA
            ctaAction={viewInvite}
            title={ INBOX_CTA_TITLES.VIEW_BOOKING_DETAILS }
          />
        ],
      borderColor: 'green'
    },
    EXPIRED: {
      title: intlGuestStatusTexts.expiredTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.expiredHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.expiredMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.expiredContent } />,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={exploreSpaces}
          title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
          primaryButton
        />,
        <InboxCTA
          ctaAction={resendRequest}
          title={ INBOX_CTA_TITLES.RESEND_BOOKING }
        />],
      borderColor: 'red'
    },
    DECLINED: {
      title: intlGuestStatusTexts.declinedTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.declinedHeading } values={{ name: firstName }} />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.declinedMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.declinedContent } />,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={exploreSpaces}
          title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
          primaryButton
        />,
        <InboxCTA
          ctaAction={resendRequest}
          title={ INBOX_CTA_TITLES.RESEND_BOOKING }
        />],
      borderColor: 'red'
    },
    EXECUTED: {
      leave_review: {
        title: intlGuestStatusTexts.executedTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.executedHeading } values={{ name: firstName }} />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.executedMobileHeading } />,
        content: <FormattedMessage { ...intlGuestStatusTexts.executedContent } values={{ name: firstName || '' }} />,
        buttons: [
          <InboxCTA
            ctaAction={review}
            title={ INBOX_CTA_TITLES.LEAVE_REVIEW }
            primaryButton
          />, iosWebView ? null :
            <InboxCTA
              ctaAction={bookAgain}
              title={ INBOX_CTA_TITLES.BOOK_AGAIN }
            />,
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
          />,
          <InboxCTA
              ctaAction={viewReceipt}
              title={ INBOX_CTA_TITLES.VIEW_RECEIPT }
          />],
        borderColor: 'orange'
      },
      completed: {
        title: intlGuestStatusTexts.completedTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.completedHeading } values={{ name: firstName || '' }} />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.completedMobileHeading } />,
        content: <></>,
        nextSteps: showReferralBanner ? <div className="inbox-next-steps-container"> <ReferralsCard /> </div> : null,
        buttons: [
          iosWebView ? null :
            <InboxCTA
              ctaAction={bookAgain}
              title={ INBOX_CTA_TITLES.BOOK_AGAIN }
            />,
          hasNoContracts ? null :
            <InboxCTA
              ctaAction={viewReceipt}
              title={ INBOX_CTA_TITLES.VIEW_RECEIPT }
            />],
        borderColor: 'black'
      }
    },
    WITHDRAWN: {
      title: intlGuestStatusTexts.withdrawnTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.withdrawnHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.withdrawnMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.withdrawnContent } />,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={exploreSpaces}
          title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
          primaryButton
        />,
        <InboxCTA
          ctaAction={resendRequest}
          title={ INBOX_CTA_TITLES.RESEND_BOOKING }
        />],
      borderColor: 'red'
    },
    UNDER_REVIEW: {
      title: intlGuestStatusTexts.underReviewTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.underReviewHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.underReviewMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.underReviewContent } />,
      borderColor: 'orange'
    },
    UNDER_REVIEW_HOST: {
      title: intlGuestStatusTexts.underReviewHostTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.underReviewHostHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.underReviewHostMobileHeading } />,
      content: [
        <FormattedMessage { ...intlGuestStatusTexts.underReviewHostContent_1 } />,
        <a href={`mailto:support@peerspace.com?subject=Guest%20Reschedule%20Request%20for%20Booking%20${bookingID}`}> <FormattedMessage { ...intlGuestStatusTexts.underReviewHostContent_2 } /></a>,
        '.'
      ],
      borderColor: 'orange'
    },
    UNDER_REVIEW_ADMIN: {
      title: intlGuestStatusTexts.underReviewAdminTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.underReviewAdminHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.underReviewAdminMobileHeading } />,
      content: [
        <FormattedMessage { ...intlGuestStatusTexts.underReviewAdminContent_1 } />,
        <a href={`mailto:support@peerspace.com?subject=Guest%20Reactivate%20Booking%20${bookingID}`}> <FormattedMessage { ...intlGuestStatusTexts.underReviewAdminContent_2 } /> </a>,
        <FormattedMessage { ...intlGuestStatusTexts.underReviewAdminContent_3 } />,
        <a href={`mailto:support@peerspace.com?subject=Guest%20Cancellation%20Support%20Request%20for%20Booking%20${bookingID}`}> <FormattedMessage { ...intlGuestStatusTexts.underReviewAdminContent_4 } /> </a>,
        <FormattedMessage { ...intlGuestStatusTexts.underReviewAdminContent_5 } />
      ],
      borderColor: 'orange'
    },
    NO_AUTH: {
      title: intlGuestStatusTexts.noAuthTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.noAuthHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.noAuthMobileHeading } />,
      content:
      <div>
        <p><FormattedMessage id='inbox.guest_status.no_auth_content_steps' defaultMessage='Here are some helpful steps to fix this issue:' /></p>
        <ul style={{ paddingLeft: '20px' }}>
          <li><FormattedMessage id='inbox.guest_status.no_auth_content_card' defaultMessage='Try a different card. Note that Peerspace does not accept pre-paid or reloadable cards.' /></li>
          <li><FormattedMessage id='inbox.guest_status.no_auth_content_bank' defaultMessage='Contact your bank to authorize the charge, then retry the transaction.' /></li>
          <li><FormattedMessage id='inbox.guest_status.no_auth_content_re_add_card' defaultMessage='If your billing zip code with your bank has changed, re-add your card with the updated zip code.' /></li>
        </ul>
      </div>,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={startBooking}
          title={ INBOX_CTA_TITLES.RETRY_BOOKING }
          primaryButton
        />,
        <InboxCTA
          ctaAction={contactSupport}
          title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
        />
      ],
      borderColor: 'red'
    },
    SETTLE_BALANCE_REQUIRED: {
      title: intlGuestStatusTexts.acceptedTitle,
      titleData: { name: firstName },
      heading: (
        <div>
          <FormattedMessage { ...intlGuestStatusTexts.settleBalanceHeading } />
        </div>
      ),
      mobileHeading: (
        <div>
          <FormattedMessage { ...intlGuestStatusTexts.settleBalanceMobileHeading } />
        </div>
      ),
      content: null,
      buttons: [
        <InboxCTA
          ctaAction={() => {
            context.router.push(
              `/inbox/${bookingID}/update-payment`
            );
          }}
          title={ INBOX_CTA_TITLES.MANAGE_PAYMENTS }
          primaryButton
        />,
        <InboxCTA
          ctaAction={contactSupport}
          title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
        />
      ],
      borderColor: 'red'
    },
    GUEST_SETTLE_BALANCE_NO_AUTH: {
      title: intlGuestStatusTexts.noAuthTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.noAuthHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.noAuthMobileHeading } />,
      content:
      <div>
        <p><FormattedMessage id='inbox.guest_status.no_auth_content_steps' defaultMessage='Here are some helpful steps to fix this issue:' /></p>
        <ul style={{ paddingLeft: '20px' }}>
          <li><FormattedMessage id='inbox.guest_status.no_auth_content_card' defaultMessage='Try a different card. Note that Peerspace does not accept pre-paid or reloadable cards.' /></li>
          <li><FormattedMessage id='inbox.guest_status.no_auth_content_bank' defaultMessage='Contact your bank to authorize the charge, then retry the transaction.' /></li>
          <li><FormattedMessage id='inbox.guest_status.no_auth_content_re_add_card' defaultMessage='If your billing zip code with your bank has changed, re-add your card with the updated zip code.' /></li>
        </ul>
      </div>,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={() => {
            context.router.push(
              `/inbox/${bookingID}/update-payment`
            );
          }}
          title={ INBOX_CTA_TITLES.RETRY_PAYMENT }
          primaryButton
        />,
        <InboxCTA
          ctaAction={contactSupport}
          title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
        />
      ],
      borderColor: 'red'
    },
    FC_NO_AUTH: {
      title: intlGuestStatusTexts.unableToProcessTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.unableToProcessHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.unableToProcessMobileHeading } />,
      content:
      <div>
        <p><FormattedMessage id='inbox.guest_status.unable_to_process_fail' defaultMessage='We’re sorry - we are unable to complete your transaction at this time.' /></p>
        <p><FormattedMessage id='inbox.guest_status.unable_to_process_more_info'
                             defaultMessage='Please note, the previous failed attempt may temporarily appear as a pending charge on your statement before being removed by your bank. Please view the {link} for more information'
                             values={{
                                 link: (
                                     <a href="https://support.peerspace.com/hc/en-us/articles/11011322137108-Why-couldn-t-my-transaction-be-processed-">FAQ</a>
                                 )
                             }}
           /></p>
      </div>,
      buttons: null,
      borderColor: 'red'
    },
    CANCELLED: {
      cancelled_by_host: {
        title: intlGuestStatusTexts.cancelledHostTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.cancelledHostHeading } values={{ name: firstName || '' }} />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.cancelledHostMobileHeading } />,
        content:
        0 < creditsIssued ?
          <div>
            <FormattedMessage { ...intlGuestStatusTexts.cancelledHostContentCredit } values={{ currency: currencySymbol, credits: creditsIssued }} /> <a onClick={routeToPaymentsPage}><FormattedMessage { ...intlGuestStatusTexts.cancelledHostContentPayments } /></a>.
          </div>
          :
          <FormattedMessage { ...intlGuestStatusTexts.cancelledHostContentCancellations } />,
        buttons: iosWebView ?
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
            primaryButton
            id="contact-support-btn"
          /> : [
            <InboxCTA
              ctaAction={exploreSpaces}
              title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
              primaryButton
              id="explore-spaces-btn"
            />,
            <InboxCTA
              ctaAction={contactSupport}
              title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
              id="contact-support-btn"
            />
          ],
        borderColor: 'red'
      },
      cancelled_by_guest: {
        title: intlGuestStatusTexts.cancelledGuestTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.cancelledGuestHeading } />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.cancelledGuestMobileHeading } />,
        content:
        0 < creditsIssued ?
          <div>
            <FormattedMessage { ...intlGuestStatusTexts.cancelledHostContentCredit } values={{ currency: currencySymbol, credits: creditsIssued }} /> <a onClick={routeToPaymentsPage}><FormattedMessage { ...intlGuestStatusTexts.cancelledHostContentPayments } /></a>.
          </div>
          : <FormattedMessage { ...intlGuestStatusTexts.cancelledGuestContent_1 } />,
        buttons: cancelledCTAs(),
        borderColor: 'red'
      },
      cancelled_by_admin: {
        title: intlGuestStatusTexts.cancelledAdminTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.cancelledAdminHeading } />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.cancelledAdminMobileHeading } />,
        content:
          0 < creditsIssued ?
            <div>
              <FormattedMessage { ...intlGuestStatusTexts.cancelledHostContentCredit } values={{ currency: currencySymbol, credits: creditsIssued }} /> <a onClick={routeToPaymentsPage}><FormattedMessage { ...intlGuestStatusTexts.cancelledHostContentPayments } /></a>.
            </div>
            : <FormattedMessage { ...intlGuestStatusTexts.cancelledAdminContent } />,
        buttons: iosWebView ?
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
            primaryButton
            id="contact-support-btn"
          /> : [
            <InboxCTA
              ctaAction={exploreSpaces}
              title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
              primaryButton
              id="explore-spaces-btn"
            />,
            <InboxCTA
              ctaAction={contactSupport}
              title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
              id="contact-support-btn"
            />
          ],
        borderColor: 'red'
      }
    },
    OFFER_SUBMITTED: {
      title: intlGuestStatusTexts.offerSubmittedTitle,
      titleData: { name: firstName },
      heading: <div><span>{firstName || ''} <FormattedMessage { ...intlGuestStatusTexts.offerSubmittedHeading } /> </span>{expiration}</div>,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.offerSubmittedMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.offerSubmittedContent } />,
      buttons:
        <InboxCTA
          ctaAction={reviewOffer}
          title={ INBOX_CTA_TITLES.REVIEW_CUSTOM_OFFER }
          primaryButton
        />,
      borderColor: 'blue'
    },
    OFFER_NO_CAPTURE: {
      title: intlGuestStatusTexts.offerNoCaptureTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.offerNoCaptureHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.offerNoCaptureMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.offerNoCaptureContent } />,
      buttons: [
        <InboxCTA
          ctaAction={reviewOffer}
          title={ INBOX_CTA_TITLES.RETRY_BOOKING }
          primaryButton
        />,
        <InboxCTA
          ctaAction={contactSupport}
          title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
        />
      ],
      borderColor: 'red'
    },
    OFFER_DECLINED: {
      title: intlGuestStatusTexts.offerDeclinedTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.offerDeclinedHeading } values={{ name: firstName }} />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.offerDeclinedMobileHeading } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.offerDeclinedContent } values={{
        name: firstName,
        ios: iosWebView
          ? <FormattedMessage id='inbox.guest_status.offer_declined_another_request' defaultMessage='send another booking request' />
          : <FormattedMessage id='inbox.guest_status.offer_declined_click_start' defaultMessage='click Start Booking to send a booking request' />
      }} />,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={startBooking}
          title={ INBOX_CTA_TITLES.START_BOOKING }
          primaryButton
        />,
        <InboxCTA
          ctaAction={exploreSpaces}
          title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
        />
      ],
      borderColor: 'red'
    },
    OFFER_WITHDRAWN: {
      title: intlGuestStatusTexts.offerWithdrawnTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.offerWithdrawnHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.offerWithdrawn } />,
      content: <FormattedMessage { ...intlGuestStatusTexts.offerWithdrawnContent } values={{
        name: firstName,
        ios: iosWebView
          ? <FormattedMessage id='inbox.guest_status.offer_withdrawn_another_request' defaultMessage='send another booking request' />
          : <FormattedMessage id='inbox.guest_status.offer_withdrawn_click_start' defaultMessage='click Request to book to reserve your date' />
      }} />,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={startBooking}
          title={ INBOX_CTA_TITLES.START_BOOKING }
          primaryButton
        />,
        <InboxCTA
          ctaAction={exploreSpaces}
          title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
        />
      ],
      borderColor: 'red'
    },
    OFFER_EXPIRED: {
      title: intlGuestStatusTexts.offerExpiredTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlGuestStatusTexts.offerExpiredHeading } values={{ name: firstName }} />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.offerExpired }/>,
      content: <FormattedMessage { ...intlGuestStatusTexts.offerExpiredContent } values={{
        name: firstName,
        hasNoContracts: hasNoContracts
          ? <FormattedMessage id='inbox.guest_status.offer_expired_business' defaultMessage='{days} business' values={{ days: <FormattedNumber value={2} /> }} />
          : <FormattedNumber value={7} />,
        ios: iosWebView
          ? <FormattedMessage id='inbox.guest_status.offer_expired_another_request' defaultMessage='send another booking request' />
          : <FormattedMessage id='inbox.guest_status.offer_expired_click_start' defaultMessage='click Start Booking to send a booking request' />

      }}
      />,
      buttons: iosWebView ? null : [
        <InboxCTA
          ctaAction={startBooking}
          title={ INBOX_CTA_TITLES.START_BOOKING }
          primaryButton
        />,
        <InboxCTA
          ctaAction={exploreSpaces}
          title={ INBOX_CTA_TITLES.EXPLORE_SPACES }
        />
      ],
      borderColor: 'red'
    },
    UPDATE_REQUESTED: {
      update_requested_by_host: {
        title: intlGuestStatusTexts.updateRequestedHostTitle,
        titleData: { name: firstName },
        heading: <div><span><FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostHeading } values={{ name: firstName }} /> </span>{expiration}</div>,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostMobileHeading } />,
        content: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostContent } />,
        buttons:
          <InboxCTA
            ctaAction={reviewOffer}
            title={ INBOX_CTA_TITLES.REVIEW_UPDATE_REQUEST }
            primaryButton
          />,
        borderColor: 'blue'
      },
      update_requested_by_host_no_auth: {
        title: intlGuestStatusTexts.updateRequestedHostNoAuthTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostNoAuthHeading } />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostNoAuthMobileHeading } />,
        content:
        <div>
          <p><FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostNoAuthContent_1 } /></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostNoAuthContent_2 } /></li>
            <li><FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostNoAuthContent_3 } /></li>
            <li><FormattedMessage { ...intlGuestStatusTexts.updateRequestedHostNoAuthContent_4 } /></li>
          </ul>
        </div>,
        buttons: [
          <InboxCTA
            ctaAction={reviewOffer}
            title={ INBOX_CTA_TITLES.RETRY_UPDATE }
            primaryButton
          />,
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
          />
        ],
        borderColor: 'red'
      },
      update_requested_by_guest: {
        title: intlGuestStatusTexts.updateRequestedGuestTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestHeading } />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestMobileHeading } />,
        content: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestContent } values={{ name: firstName }} />,
        buttons:
          <InboxCTA
            ctaAction={withdrawUpdate}
            title={ INBOX_CTA_TITLES.WITHDRAW_UPDATE }
          />,
        borderColor: 'blue'
      },
      update_requested_by_guest_no_auth: {
        title: intlGuestStatusTexts.updateRequestedGuestNoAuthTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestNoAuthHeading } />,
        mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestNoAuthMobileHeading } />,
        content:
        <div>
          <p><FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestNoAuthContent_1 } /></p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestNoAuthContent_2 } /></li>
            <li><FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestNoAuthContent_3 } /></li>
            <li><FormattedMessage { ...intlGuestStatusTexts.updateRequestedGuestNoAuthContent_4 } /></li>
          </ul>
        </div>,
        showRequestUpdateModal: iosWebView ? requestUpdate : null,
        buttons: [
          <InboxCTA
            ctaAction={requestUpdate}
            title={ INBOX_CTA_TITLES.RETRY_UPDATE }
            primaryButton
          />,
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
          />
        ],
        borderColor: 'red'
      }
    },
    GUEST_CLIENT_ACTION_NEEDED: {
      title: intlGuestStatusTexts.guestClientNeededAuthorizePayment,
      heading: <FormattedMessage { ...intlGuestStatusTexts.guestClientNeededAuthorizePayment } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.guestClientNeededAuthorizePayment } />,
      content:
      <div>
        <p>
          <FormattedMessage id='inbox.guest_status.action_needed' defaultMessage="Your payment method requires additional action to authorize the payment."/>
        </p>
      </div>,
      buttons: [
        <InboxCTA
          key={0}
          ctaCallback={() => {}}
          ctaAction={() =>
            checkCCStateInterval(
              bookingID,
              accessToken,
              () => {
                window.location.reload();
              },
              true
            )
          }
          title={INBOX_CTA_TITLES.AUTHORIZE_PAYMENT}
          primaryButton
        />
      ],
      borderColor: 'red'
    },
    NO_STATE: {
      heading: <FormattedMessage { ...intlGuestStatusTexts.noStateHeading } />,
      mobileHeading: <FormattedMessage { ...intlGuestStatusTexts.noStateMobileHeading } />,
      inboxHeading: ' ',
      content: <FormattedMessage { ...intlGuestStatusTexts.noStateContent } />,
      buttons:
        <InboxCTA
          ctaAction={contactSupport}
          title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
          primaryButton
        />,
      borderColor: 'red'
    }
  };
};

export const HostStatus = (firstName, expires, user, bookingID, cb2, listingId, pid, reviewID, reviewCb, payload, context, iosWebView, hostCanUpdate, canInstantBook, showCancellationSummary, accessToken, hasNoContracts, dispatch) => {
  /**
   *
   * @function
   * @name CTA Buttons
   * @param {Object}   - User Object
   * @param {String}   - Booking ID
   * @param {Function} - cb2
   * @param {String} - actionName
   * @param {String} - listingId
   * @param {String} - pid
   * @param {String} - reviewID
   * @param {Function} - reviewCb
   * @param {Object} - payload
   */
  const expiration = expires ? <span className="expire-pill">
    <FormattedMessage { ...intlHostStatusTexts.expiresIn } values={{
      value: expires.value,
      unit: 'h' === expires.unit
        ? <FormattedMessage id='inbox.host_status.hours' defaultMessage='hrs' description='hours' />
        : <FormattedMessage id='inbox.host_status.minutes' defaultMessage='mins' description='minutes' />
    }} />
  </span> : '';
  const boltIcon = <img className="bolt-icon" src="/web-2/assets/images/bolt.png?v=rb" alt="bolt-icon" />;
  const isInstantBooking = (payload || {}).is_instant_booking;
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

  // message content by IB and hostCanUpdate
  const IBandHostCanUpdate = <div>Congratulations, this Instant Booking is confirmed! If you need to update the date, time, price, or add services use the Update Booking button below.</div>;
  const nonIBandHostCanUpdate = <div>Congratulations, this Booking is confirmed! If you need to update the date, time, price, or add services use the Update Booking button below.</div>;
  // start host cta action functions
  function reviewBookingRequest () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <ReviewRequestIOSModal
              accessToken={accessToken}
              bookingId={bookingID}
              profile={user}
              finalCb={cb2}
              iosWebView
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }
    return context.router.push(`/inbox/${bookingID}/review-request`);
  }

  function reviewUpdateRequest () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <UpdateBookingIOSModal
              updateAction="REVIEW_UPDATE"
              accessToken={accessToken}
              user={user}
              bookingID={bookingID}
              customCb={cb2}
              isHost
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }

    window.location.href = `/inbox/${bookingID}/review-booking-update`;
  }

  function offerCustomPrice () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CustomOfferIOSModal
              offerAction="OFFER_CUSTOM_PRICE"
              accessToken={accessToken}
              bookingID={bookingID}
              user={user}
              finalCb={cb2}
              iosWebView
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }

    window.location.href = `/inbox/${bookingID}/offer-custom-price`;
  }

  function editOffer () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CustomOfferIOSModal
              offerAction="EDIT_CUSTOM_PRICE"
              accessToken={accessToken}
              bookingID={bookingID}
              user={user}
              finalCb={cb2}
              isEdit
              iosWebView
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }

    return context.router.push(`/inbox/${bookingID}/edit-offer`);
  }

  function withdrawContractOffer () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <WithdrawOfferModal
          offerAction="WITHDRAW_OFFER"
          bookingId={ bookingID }
          callback={ cb2 }
        />
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  function withdrawUpdate () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <WithdrawUpdateModal
          viewAs={ payload.view_as }
          bookingID={ bookingID }
          callback={ cb2 }
          hasNoContracts={ hasNoContracts }
        />
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  function hostCancel () {
    renderBookingModal(bookingID, 'host', 'cancel', 'HOST_CANCEL', cb2, payload);
  }

  function requestUpdate () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));

      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CustomOfferIOSModal
              offerAction="OFFER_CUSTOM_PRICE"
              accessToken={accessToken}
              bookingID={bookingID}
              user={user}
              finalCb={cb2}
              isHostUpdate
              iosWebView
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));

      return null;
    }

    window.location.href = `/inbox/${bookingID}/host-update-booking`;
  }

  function review () {
    Reviews.read(`/${reviewID}`, PSSessions.Cookies('PSAccess'),
      (response) => {
        if (response.error || 400 < response.statusCode) {
        // Something went wrong when creating the message
          return console.log(response);
        }
        ReactDOM.render(
          <SharedIntlProviderHOC>
            <Modal
              addCloseIcon
              modalID="review-modal"
              closeBehavior={null}
              body={
                <ReviewForm
                  review={response}
                  user={user}
                  cbAction={reviewCb}
                />
              }
              footer={null}
              show
              modalSize="lg-size"
              modalType="standard"
            />
          </SharedIntlProviderHOC>, document.getElementById('modal-container')
        );
        return null;
      });
  }

  function addPayoutInfo () {
    window.location.href = '/account/host';
  }

  function contactSupport () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <SupportModal />
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  function viewCancellationDetails () {
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CancelBookingIOSModal
              bookingID={bookingID}
              customCb={cb2}
              profile={user}
              summary
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }
    return context.router.push(`/inbox/${bookingID}/cancellation-summary`);
  }

  function renderHostCustomOfferBanner (isHostUpdate) {
    return (
      <HostCustomOfferBanner updateBooking={isHostUpdate}>
        {[isHostUpdate ?
          <InboxCTA
            ctaAction={requestUpdate}
            title={ INBOX_CTA_TITLES.UPDATE_BOOKING }
            accessToken={accessToken}
            dispatch={dispatch}
            iosWebView={iosWebView}
            isHost
          />
          :
          <InboxCTA
            ctaAction={offerCustomPrice}
            title={ INBOX_CTA_TITLES.CREATE_CUSTOM_OFFER }
            accessToken={accessToken}
            dispatch={dispatch}
            iosWebView={iosWebView}
            primaryButton
            isHost
          />
        ]}
      </HostCustomOfferBanner>
    )
  }
  // end host cta action functions

  return {
    INQUIRED: {
      title: intlHostStatusTexts.inquiredTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.inquiredHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.inquiredMobileHeading } />,
      nextSteps: renderHostCustomOfferBanner(),
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      buttons: null,
      borderColor: 'blue'
    },
    REQUESTED: {
      title: intlHostStatusTexts.requestedTitle,
      titleData: { name: firstName },
      heading: <div><span><FormattedMessage { ...intlHostStatusTexts.requestedHeading } values={{ name: firstName }} /> </span>{expiration}</div>,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.requestedMobileHeading } />,
      content: null,
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      showReviewBookingRequestModal: iosWebView ? reviewBookingRequest : null,
      buttons: [
        <InboxCTA
          ctaAction={reviewBookingRequest}
          title={ INBOX_CTA_TITLES.REVIEW_BOOKING_REQUEST }
          primaryButton
        />,
        <InboxCTA
        ctaAction={offerCustomPrice}
        title={ INBOX_CTA_TITLES.CREATE_OFFER }
      />],
      borderColor: 'blue'
    },
    ACCEPTED: {
      title: intlHostStatusTexts.acceptedTitle,
      titleData: { name: firstName },
      heading: <div>{isInstantBooking ? boltIcon : null}<FormattedMessage { ...intlHostStatusTexts.acceptedHeading } /></div>,
      mobileHeading: <div>{isInstantBooking ? boltIcon : null}<FormattedMessage { ...intlHostStatusTexts.acceptedMobileHeading } /></div>,
      content: null,
      showCustomOfferModal: hostCanUpdate && iosWebView ? requestUpdate : null,
      buttons:
      [((user || {}).bankStatus || {}).ready_for_bank && !iosWebView ?
        <InboxCTA
          ctaAction={addPayoutInfo}
          title={ INBOX_CTA_TITLES.ADD_PAYOUT_INFO }
          primaryButton
        /> : null,
      <InboxCTA
        ctaAction={hostCancel}
        title={ INBOX_CTA_TITLES.CANCEL_BOOKING }
      />,
      <InboxCTA
        ctaAction={requestUpdate}
        title={ INBOX_CTA_TITLES.UPDATE_BOOKING }
        accessToken={accessToken}
        dispatch={dispatch}
        iosWebView={iosWebView}
        isHost
      />
      ],
      borderColor: 'green'
    },
    EXPIRED: {
      title: intlHostStatusTexts.expiredTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.expiredHeading } values={{ name: firstName }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.expiredMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.expiredContent } values={{ name: firstName }} />,
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      buttons:
        <InboxCTA
          ctaAction={offerCustomPrice}
          title={ INBOX_CTA_TITLES.OFFER_CUSTOM_PRICE }
          accessToken={accessToken}
          dispatch={dispatch}
          iosWebView={iosWebView}
        />,
      borderColor: 'red'
    },
    DECLINED: {
      title: intlHostStatusTexts.declinedTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.declinedHeading } values={{ name: firstName }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.declinedMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.declinedContent } values={{ name: firstName || '' }} />,
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      buttons:
        <InboxCTA
          ctaAction={offerCustomPrice}
          title={ INBOX_CTA_TITLES.OFFER_CUSTOM_PRICE }
          accessToken={accessToken}
          dispatch={dispatch}
          iosWebView={iosWebView}
        />,
      borderColor: 'red'
    },
    EXECUTED: {
      leave_review: {
        title: intlHostStatusTexts.executedReviewTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlHostStatusTexts.executedReviewHeading } values={{ name: firstName }} />,
        mobileHeading: <FormattedMessage { ...intlHostStatusTexts.executedReviewMobileHeading } />,
        content: <FormattedMessage { ...intlHostStatusTexts.executedReviewContent } values={{ name: firstName }} />,
        buttons: [
          <InboxCTA
            ctaAction={review}
            title={ INBOX_CTA_TITLES.LEAVE_REVIEW }
            primaryButton
          />,
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
          />
        ],
        borderColor: 'orange'
      },
      completed: {
        title: intlHostStatusTexts.executedCompletedTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlHostStatusTexts.executedCompletedHeading } values={{ name: firstName || '' }} />,
        mobileHeading: <FormattedMessage { ...intlHostStatusTexts.executedCompletedMobileHeading } />,
        content: '',
        buttons:
        [((user || {}).bankStatus || {}).ready_for_bank && !iosWebView ?
          <InboxCTA
            ctaAction={addPayoutInfo}
            title={ INBOX_CTA_TITLES.ADD_PAYOUT_INFO }
            primaryButton
          /> : null],
        borderColor: 'black'
      }
    },
    WITHDRAWN: {
      title: intlHostStatusTexts.withdrawnTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.withdrawnHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.withdrawnMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.withdrawnContent } values={{ name: firstName }} />,
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      buttons:
        <InboxCTA
          ctaAction={offerCustomPrice}
          title={ INBOX_CTA_TITLES.CREATE_CUSTOM_OFFER }
          accessToken={accessToken}
          dispatch={dispatch}
          iosWebView={iosWebView}
        />,
      borderColor: 'red'
    },
    UNDER_REVIEW: {
      title: intlHostStatusTexts.underReviewTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.underReviewHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.underReviewMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.underReviewContent } />,
      borderColor: 'orange'
    },
    UNDER_REVIEW_ADMIN: {
      title: intlHostStatusTexts.underReviewAdminTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.underReviewAdminHeading } />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.underReviewAdminMobileHeading } />,
      content: [
        <FormattedMessage { ...intlHostStatusTexts.underReviewAdminContent_1 } />,
        <a href={`mailto:support@peerspace.com?subject=Host%20Reactivate%20Booking%20${bookingID}`}> <FormattedMessage { ...intlHostStatusTexts.underReviewAdminContent_2 } /></a>,
        <FormattedMessage { ...intlHostStatusTexts.underReviewAdminContent_3 } />,
        <a href={`mailto:support@peerspace.com?subject=Host%20Cancellation%20Support%20Request%20for%20Booking%20${bookingID}`}> <FormattedMessage { ...intlHostStatusTexts.underReviewAdminContent_4 } /> </a>,
        <FormattedMessage { ...intlHostStatusTexts.underReviewAdminContent_5 } />
      ],
      borderColor: 'orange'
    },
    CANCELLED: {
      cancelled_by_host: {
        title: intlHostStatusTexts.cancelledHostTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlHostStatusTexts.cancelledHostHeading } values={{ name: firstName || '' }} />,
        mobileHeading: <FormattedMessage { ...intlHostStatusTexts.cancelledHostMobileHeading } />,
        content: isInstantBooking ?
          <div><p><FormattedMessage { ...intlHostStatusTexts.cancelledHostContent_1 } /> <a href={`//support.peerspace.com/hc/${zendeskLocale}/articles/360018674331-Can-I-cancel-an-Instant-Booking`}><FormattedMessage { ...intlHostStatusTexts.cancelledHostContent_2 } /></a></p></div> :
          <div><p><FormattedMessage { ...intlHostStatusTexts.cancelledHostContent_3 } /> <a href={`//support.peerspace.com/hc/${zendeskLocale}/articles/201745713-What-if-I-need-to-cancel-a-booking-I-confirmed-with-a-guest`}><FormattedMessage { ...intlHostStatusTexts.cancelledHostContent_2 } /></a></p></div>,
        buttons:
        [((user || {}).bankStatus || {}).ready_for_bank && !iosWebView ?
          <InboxCTA
            ctaAction={addPayoutInfo}
            title={ INBOX_CTA_TITLES.ADD_PAYOUT_INFO }
            primaryButton
          /> : null,
        <InboxCTA
          ctaAction={contactSupport}
          title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
          primaryButton={!((user || {}).bankStatus || {}).ready_for_bank && !iosWebView}
          id="contact-support-btn"
        />],
        borderColor: 'red'
      },
      cancelled_by_guest: {
        title: intlHostStatusTexts.cancelledGuestHeading,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlHostStatusTexts.cancelledGuestHeading } values={{ name: firstName || '' }} />,
        mobileHeading: <FormattedMessage { ...intlHostStatusTexts.cancelledGuestMobileHeading } />,
        content: '',
        buttons: (showCancellationSummary ?
          [<InboxCTA
            ctaAction={viewCancellationDetails}
            title={ INBOX_CTA_TITLES.VIEW_CANCELLATION_DETAILS }
            id="view-cancellation-details-btn"
          />,
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
            id="contact-support-btn"
          />] : null),
        borderColor: 'red'
      },
      cancelled_by_admin: {
        title: intlHostStatusTexts.cancelledAdminTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlHostStatusTexts.cancelledAdminHeading } />,
        mobileHeading: <FormattedMessage { ...intlHostStatusTexts.cancelledAdminMobileHeading } />,
        content: <FormattedMessage { ...intlHostStatusTexts.cancelledAdminMobileContent } />,
        buttons:
          <InboxCTA
            ctaAction={contactSupport}
            title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
            primaryButton
            id="contact-support-btn"
          />,
        borderColor: 'red'
      }
    },
    OFFER_SUBMITTED: {
      title: intlHostStatusTexts.offerSubmittedTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.offerSubmittedHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.offerSubmittedMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.offerSubmittedContent } values={{
        name: firstName,
        hasNoContracts: hasNoContracts
          ? <FormattedMessage id='inbox.host_status.offer_submitted_business' defaultMessage='{days} business' values={{ days: <FormattedNumber value={2} /> }} />
          : <FormattedNumber value={7} />
      }} />,
      showCustomOfferModal: !hasNoContracts && iosWebView ? editOffer : null,
      buttons: hasNoContracts ?
        <InboxCTA
          ctaAction={withdrawContractOffer}
          title={ INBOX_CTA_TITLES.WITHDRAW_OFFER }
        /> :
        [
          <InboxCTA
            ctaAction={editOffer}
            title={ INBOX_CTA_TITLES.EDIT_OFFER }
          />,
          <InboxCTA
            ctaAction={withdrawContractOffer}
            title={ INBOX_CTA_TITLES.WITHDRAW_OFFER }
          />
        ],
      borderColor: 'blue'
    },
    OFFER_NO_CAPTURE: {
      title: intlHostStatusTexts.offerNoCaptureTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.offerNoCaptureHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.offerNoCaptureMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.offerNoCaptureContent } values={{ name: firstName }} />,
      buttons:
        <InboxCTA
          ctaAction={withdrawContractOffer}
          title={ INBOX_CTA_TITLES.WITHDRAW_OFFER }
        />,
      borderColor: 'blue'
    },
    OFFER_DECLINED: {
      title: intlHostStatusTexts.offerDeclinedTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.offerDeclinedHeading } values={{ name: firstName || '' }} />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.offerDeclinedMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.offerDeclinedMobileHeading } values={{ name: firstName || '' }} />,
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      buttons:
        <InboxCTA
          ctaAction={offerCustomPrice}
          title={ INBOX_CTA_TITLES.OFFER_CUSTOM_PRICE }
          accessToken={accessToken}
          dispatch={dispatch}
          iosWebView={iosWebView}
        />,
      borderColor: 'red'
    },
    OFFER_WITHDRAWN: {
      title: intlHostStatusTexts.offerWithdrawnTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.offerWithdrawnHeading } />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.offerWithdrawnMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.offerWithdrawnContent } values={{ name: firstName }} />,
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      buttons:
        <InboxCTA
          ctaAction={offerCustomPrice}
          title={ INBOX_CTA_TITLES.OFFER_CUSTOM_PRICE }
          accessToken={accessToken}
          dispatch={dispatch}
          iosWebView={iosWebView}
          primaryButton
        />,
      borderColor: 'red'
    },
    OFFER_EXPIRED: {
      title: intlHostStatusTexts.offerExpiredTitle,
      titleData: { name: firstName },
      heading: <FormattedMessage { ...intlHostStatusTexts.offerExpiredHeading } />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.offerExpiredMobileHeading } />,
      content: <FormattedMessage { ...intlHostStatusTexts.offerExpiredContent } values={{
        name: firstName || '',
        noContracts: hasNoContracts
          ? <FormattedMessage id='inbox.host_status.offer_expired_business' defaultMessage='{days} business' values={{ days: <FormattedNumber value={2} /> }} />
          : <FormattedNumber value={7} />
      }} />,
      showCustomOfferModal: iosWebView ? offerCustomPrice : null,
      buttons:
        <InboxCTA
          ctaAction={offerCustomPrice}
          title={ INBOX_CTA_TITLES.OFFER_CUSTOM_PRICE }
          accessToken={accessToken}
          dispatch={dispatch}
          iosWebView={iosWebView}
        />,
      borderColor: 'red'
    },
    UPDATE_REQUESTED: {
      update_requested_by_host: {
        title: intlHostStatusTexts.updateRequestedHostTitle,
        titleData: { name: firstName },
        heading: <FormattedMessage { ...intlHostStatusTexts.updateRequestedHostHeading } />,
        mobileHeading: <FormattedMessage { ...intlHostStatusTexts.updateRequestedHostMobileHeading } />,
        content: <FormattedMessage { ...intlHostStatusTexts.updateRequestedHostContent } values={{ name: firstName }} />,
        buttons: [
          <InboxCTA
            ctaAction={withdrawUpdate}
            title={ INBOX_CTA_TITLES.WITHDRAW_UPDATE }
          />
        ],
        borderColor: 'blue'
      },
      update_requested_by_guest: {
        title: intlHostStatusTexts.updateRequestedGuestTitle,
        titleData: { name: firstName },
        heading: <div><span><FormattedMessage { ...intlHostStatusTexts.updateRequestedGuestHeading } values={{ name: firstName }} /> </span>{expiration}</div>,
        mobileHeading: <FormattedMessage { ...intlHostStatusTexts.updateRequestedGuestMobileHeading } />,
        content: <FormattedMessage { ...intlHostStatusTexts.updateRequestedGuestContent } />,
        buttons: [
          <InboxCTA
            ctaAction={reviewUpdateRequest}
            title={ INBOX_CTA_TITLES.REVIEW_UPDATE_REQUEST }
            primaryButton
          />
        ],
        borderColor: 'blue'
      }
    },
    NO_STATE: {
      heading: <FormattedMessage { ...intlHostStatusTexts.noStateHeading } />,
      mobileHeading: <FormattedMessage { ...intlHostStatusTexts.noStateMobileHeading } />,
      inboxHeading: ' ',
      content: <FormattedMessage { ...intlHostStatusTexts.noStateMobileContent } />,
      buttons:
        <InboxCTA
          ctaAction={contactSupport}
          title={ INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT }
        />,
      borderColor: 'red'
    }
  };
};
